import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from '../../../../context/API';
import { notification } from '../../../../commonComponents/Notification/Notification';
import { QUERY_KEYS as ITEMS_QUERY_KEYS } from '../../../Items/constants';
import { QUERY_KEYS } from '../constants';

export function useMarkAvailable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number | string) => API.put(`/items/${id}`, { sold_out: false }),
    onSuccess: () => {
      notification.success(
        'Item status updated',
        'The item is now available and will be removed from the sold out list.',
        5
      );
    },
    onError: () => {
      notification.error('An error occurred', 'Unable to update the item.', 5);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SOLD_OUT_ITEMS] });
      queryClient.invalidateQueries({ queryKey: [ITEMS_QUERY_KEYS.ITEMS] });
    },
  });
}
